<template>
  <div>
    <div class="page-header">
      <h2 class="main-content-title tx-24 mg-b-5">{{$t('profile.title')}}</h2>
      <div class="d-flex">
        <div class="justify-content-center">
        </div>
      </div>
    </div>
    <div class="row square" :class="loading ? 'cursor-wait' : ''">
      <div class="col-lg-12 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div class="panel profile-cover py-5">
              <div class="profile-cover__img">
                <span class="media-icon bg-primary image-plus">
                  <input type="file" name="avatar" accept="image/jpeg,image/png"
                         :disabled="loading" :class="loading ? 'button-readonly' : ''"
                         @change="uploadImage($event.target.files)">
                   <i class="fas fa-camera"></i>
                </span>
                <img v-if="user && user.avatar_path" :src="user.avatar_path" alt="">
                <img v-else src="../../../assets/img/users/default.png" alt="">
                <h3  v-if="user && user.name"  class="h3">{{ user.name }}</h3>
              </div>
              <div class="btn-profile">
                <h4>{{$t('profile.myProfile')}}</h4>
              </div>
              <div class="profile-cover__action bg-img">
              </div>
              <div class="profile-cover__info">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12 col-md-12">
        <div class="card custom-card main-content-body-profile">
          <div class="card-body border" data-select2-id="12">
            <div class="main-content-body tab-pane p-4 border-top-0 active" id="settings">
              <div class="card-body border" data-select2-id="12">
                <ValidationObserver class="form-horizontal" data-select2-id="11" tag="form" ref="editFormData"
                                    @submit.prevent="editUserInfo()">
                  <div class="mb-4 main-content-label">{{$t('profile.account')}}</div>
                  <ValidationProvider
                      tag="div"
                      v-slot="{ validate, classes }"
                      rules="required"
                      class="form-group text-left">
                    <div class="row row-sm">
                      <div class="col-md-3">
                        <label class="form-label" for="user-name">{{$t('profile.yourName')}}</label>
                      </div>
                      <div class="col-md-9">
                        <input
                            @input="validate"
                            name="userName"
                            class="form-control"
                            id="user-name"
                            v-model="userFormData.name"
                            type="text"
                            :placeholder="$t('profile.yourName')"
                            :class="classes"
                            size="lg"
                        />
                      </div>
                    </div>
                  </ValidationProvider>
                  <div class="form-group text-left">
                    <div class="row row-sm">
                      <div class="col-md-3">
                        <label class="form-label" for="email">{{$t('profile.email')}}</label>
                      </div>
                      <div class="col-md-9">
                        <input id="email"
                               type="email"
                               name="email"
                               class="form-control"
                               v-model="userFormData.email"
                               :placeholder="$t('profile.email')"
                               size="lg"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group ">
                    <div class="row row-sm">
                      <div class="col-md-3"></div>
                      <div class="col-md-9">
                        <button :disabled="disableAccountBtn" type="submit" class="btn btn-primary my-2 btn-icon-text">
                          {{$t('profile.save')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12 col-md-12">
        <div class="card custom-card main-content-body-profile">
          <div class="card-body border" data-select2-id="12">
            <div class="main-content-body tab-pane p-4 border-top-0 active">
              <div class="card-body border" data-select2-id="12">
                <ValidationObserver class="form-horizontal" data-select2-id="11" tag="form" ref="updatePasswordForm"
                                    @submit.prevent="passwordConfirmation()">
                  <div class="mb-4 main-content-label">{{$t('profile.changePassword')}}</div>
                  <ValidationProvider
                      tag="div"
                      v-slot="{ validate, classes }"
                      rules="required|min:6|"
                      class="form-group text-left">
                    <div class="row row-sm">
                      <div class="col-md-3">
                        <label class="form-label" for="password">{{$t('profile.yourPassword')}}</label>
                      </div>
                      <div class="col-md-9">
                        <input
                            id="password"
                            v-model="changePassword.current_password"
                            :class="classes"
                            @input="validate"
                            type="password"
                            name="password"
                            class="form-control"
                            :placeholder="$t('profile.yourPassword')"
                        />
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                      tag="div"
                      class="form-group text-left pos-relative mb-4"
                      name="Password"
                      rules="required|min:6"
                      vid="confirmation"
                      v-slot="{ validate, errors, classes }"
                  >
                    <div class="row row-sm">
                      <div class="col-md-3">
                        <label class="form-label" for="password-confirm">{{$t('profile.strongPassword')}}</label>
                      </div>
                      <div class="col-md-9">
                        <input
                            name="password"
                            class="form-control"
                            id="password-confirm"
                            v-model="changePassword.password"
                            type="password"
                            :placeholder="$t('profile.strongPassword')"
                            :class="classes"
                            @input="validate"
                            aria-describedby="password-confirm-live-feedback"
                            size="lg"
                        />
                        <b-form-invalid-feedback class="pos-absolute" id="password-confirm-live-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                      tag="div"
                      class="form-group text-left pos-relative"
                      name="Confirm Password"
                      rules="required|min:6|confirmed:confirmation"
                      v-slot="{ validate, errors, classes }"
                  >
                    <div class="row row-sm">
                      <div class="col-md-3">
                        <label class="form-label" for="newPassword">{{$t('profile.confirmPassword')}}</label>
                      </div>
                      <div class="col-md-9">
                        <input id="newPassword"
                               :class="classes"
                               @input="validate"
                               type="password"
                               name="confirm_password"
                               class="form-control"
                               v-model="changePassword.password_confirmation"
                               :placeholder="$t('profile.confirmPassword')"
                               aria-describedby="password-live-feedback"
                               size="lg"
                        />
                        <b-form-invalid-feedback class="pos-absolute" id="password-live-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                  </ValidationProvider>
                  <div class="form-group ">
                    <div class="row row-sm">
                      <div class="col-md-3"></div>
                      <div class="col-md-9">
                        <button type="submit" class="btn btn-primary my-2 btn-icon-text">
                          {{$t('profile.save')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MyProfile',
  data: function () {
    return {
      loading: false,
      disableAccountBtn: false,
      userFormData: {},
      changePassword: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted () {
    this.userFormData = { ...this.user }
  },
  methods: {
    ...mapActions({
      updateUserInfo: 'auth/updateUserInfo',
      updatePassword: 'auth/updatePassword',
      uploadUserImage: 'auth/uploadUserImage'
    }),
    uploadImage (file) {
      this.loading = true
      const formData = new FormData()
      formData.append('avatar', file[0])
      this.uploadUserImage(formData).then(() => {
        this.$toasted.success('User added successfully!').goAway(1500)
      }).catch(err => {
        if (err.response.status === 422) {
          const data = err.response.data.errors
          const keys = Object.keys(data)
          const msg = data[keys[0]][0]
          this.$toasted.error(msg).goAway(1500)
        } else {
          this.$toasted.error('Server error!').goAway(1500)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    editUserInfo () {
      this.$refs.editFormData.validate().then(res => {
        if (res) {
          this.disableAccountBtn = true
          this.updateUserInfo({
            id: this.userFormData.id,
            name: this.userFormData.name,
            email: this.userFormData.email
          }).then(() => {
            this.$toasted.success('User info changed successfully:').goAway(1500)
          }).catch(err => {
            if (err.response.status === 422) {
              const data = err.response.data.errors
              const keys = Object.keys(data)
              const msg = data[keys[0]][0]
              this.$toasted.error(msg).goAway(1500)
            } else {
              this.$toasted.error('Server error!').goAway(1500)
            }
          }).finally(() => {
            this.disableAccountBtn = false
          })
        }
      })
    },
    passwordConfirmation () {
      this.$refs.updatePasswordForm.validate().then(success => {
        if (success) {
          this.updatePassword(this.changePassword).then(() => {
            this.$toasted.success('password changed successfully:').goAway(1500)
            this.changePassword = {
              confirm_password: null,
              password: null,
              current_password: null
            }
            this.$refs.updatePasswordForm.reset()
          }).catch(err => {
            if (err.response.status === 422) {
              const data = err.response.data.errors
              const keys = Object.keys(data)
              const msg = data[keys[0]][0]
              this.$toasted.error(msg).goAway(1500)
            } else {
              this.$toasted.error('You have entered wrong password!').goAway(1500)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
   .image-plus{
     position: absolute;
     left: 80px;
     top: 75px;
     background-color: #6259ca38;
     input{
       position: absolute;
       z-index: 2;
       width: 100%;
       height: 100%;
       opacity: 0;
       cursor: pointer;
     }
   }
 </style>
